import React, {useState} from 'react';
import style from './style.module.scss';
import {IHandlers, IProps} from './types';
import {Grid} from '@material-ui/core';
import classNames from "classnames";
import { IBookingLink } from "shared-types/index";
import {cloneDeep} from "lodash-es";
import BookingLinkItem from "app/common/BookingLinkItem";
import ActionButton from 'design-v2/common/ActionButton';
import { IconPosition } from 'design-v2/common/ActionButton/types';
import { IconTypes } from 'app/services/icons/icons.types';

const NS = 'BookingLinks';

export default function BookingLinks({bookingLinks, updateBookingLink, addBookingLink, editMode, useDesignV2}: IProps & IHandlers) {

  function deleteBookingLink(bookingLinks: IBookingLink[], index: number) {
    const newBookingLinks = cloneDeep(bookingLinks);
    newBookingLinks.splice(index, 1);
    updateBookingLink(newBookingLinks);
  }
  const classes = {
    [style.root]: true,
    [style.isDesignV2]: useDesignV2,
  }
  return (
    <Grid className={classNames(classes)} data-testid="container">
      {useDesignV2? <span className={style.title} data-testid="v2-title">Links</span> : null}
      {bookingLinks.map((link, index) => {
        return (
          <div key={index}>
            <BookingLinkItem link={link} index={index}
             updateLinkName={(linkName: string) => {
               bookingLinks[index].linkName = linkName;
               return updateBookingLink(bookingLinks);
             }}
             updateLinkURL={(linkURL: string) => {
               bookingLinks[index].linkURL = linkURL;
               return updateBookingLink(bookingLinks);
             }}
             deleteLink={(index: number) => {
               deleteBookingLink(bookingLinks, index)
             }}
             editMode={editMode}
            />
          </div>

        )
      })}
      <Grid container className={classNames({
        [style.root]: true,
        [style.box]: true,
        [style.designV2Box]: true,
      })} spacing={3} data-testid="edit-links-container">
        <ActionButton
          data-testid="v2-button"
          handleClick={addBookingLink} useBorderRadiusV2={true} useThemeColor={true}
          variant={'secondary'} size="large" text={'Add a link'}
          icon={{iconPosition: IconPosition.LEFT, iconType: IconTypes.addCircle}}
        />
      </Grid>
    </Grid>
  )
}

